// src/icons/ThemeIcons.tsx
import type { SVGProps } from "react";

export const SunIcon = ({
  className = "",
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    className={className}
    aria-hidden
    {...props}
  >
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2M12 20v2M2 12h2M20 12h2" />
    <path d="M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41" />
    <path d="M19.07 4.93l-1.41 1.41M6.34 17.66l-1.41 1.41" />
  </svg>
);

export const MoonIcon = ({
  className = "",
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    aria-hidden
    {...props}
  >
    <path d="M21 12.79A9 9 0 1 1 11.21 3a7 7 0 0 0 9.79 9.79z" />
  </svg>
);
